'use client';

import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import React, { useState } from 'react';
import { Context as ResponsiveContext } from 'react-responsive';

// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import useClientSide from '../../utils/hook/useClientSide';

const LayoutProviders = ({
  children,
  isMobileSSR,
}: {
  children: React.ReactNode;
  isMobileSSR: boolean;
}) => {
  const queryClientConfig = {
    defaultOptions: {
      queries: {
        retry: false, // 쿼리 요청 실패시, 재요청 금지
      },
    },
    queryCache: new QueryCache({
      onError: (error, query) => {
        if (typeof query.meta?.onError === 'function') {
          query.meta.onError(error);
        }
      },
      onSuccess: (data, query) => {
        if (typeof query.meta?.onSuccess === 'function') {
          query.meta.onSuccess(data);
        }
      },
    }),
  };

  const [queryClient] = useState(() => new QueryClient(queryClientConfig));

  const isClientSide = useClientSide();

  /**
   * 가장 많이 사용되는 MAX_WIDTH_639PX를 기준으로 정한 임의의 값
   */
  const VIRTUAL_WIDTH = isMobileSSR ? 375 : 1000;

  return (
    /**
     * @link https://tanstack.com/query/v4/docs/react/guides/ssr#using-the-app-directory-in-nextjs-13
     */
    <QueryClientProvider client={queryClient}>
      {/* <ReactQueryDevtools initialIsOpen={true} buttonPosition="bottom-right" /> */}
      {/*
       * 🚨 페이지 초기 렌더링 시에만 isClientSide의 의존으로 리렌더링 될 수 있지만, 추가 상태 변경은 있을 수 없기 때문에 리렌더링이 일어나지 않는다.
       * Server-side에서는 viewport를 모르기 때문에 VIRTUAL_WIDTH으로 mocking 한다
       * @link https://github.com/yocontra/react-responsive?tab=readme-ov-file#server-side-rendering
       */}
      <ResponsiveContext.Provider
        value={isClientSide ? undefined : { width: VIRTUAL_WIDTH }}
      >
        {children}
      </ResponsiveContext.Provider>
    </QueryClientProvider>
  );
};

export default LayoutProviders;
